module.exports = __webpack_public_path__ + "static/media/example3.910b35aa.jpg";